import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faUser } from "@fortawesome/free-solid-svg-icons";
import AddCommunication from "./AddCommunication";
import AssignCommunication from "./AssignCommunication";
import ToastComp from "../../../components/Toast/Toast";
import axios from "axios";
import { API } from "../../../config/API";
import Loader from "../../../components/Loader/Loader";
import { Util } from "../../../config/Util";
import "./Communication.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast from "react-hot-toast";

export default class Communication extends Component {
  constructor() {
    super();
    this.rowData = {};
    this.columns = [
      {
        id: "id",
        name: "ID",
        selector: (row) => row.id,
        width: '80px'
      },
      {
        name: "TITLE",
        selector: (row) => row.name,
        grow: 2
      },
      {
        name: "CREATED DATE",
        selector: (row) => row.validfrom,
        grow: 0.25
      },
      {
        name: "EXPIRY DATE",
        selector: (row) => row.validto,
        grow: 0.25

      },
      {
        name: "TYPE",
        selector: props => this.formatType(props.isAnnouncement),
        grow: 0.25

      },
      {
        cell: (row) => (
          <button
            id={row.id}
            className="btn btn-info"
            onClick={() => this.editCommunicationOpen(row)}
          >
            {" "}
            <FontAwesomeIcon icon={faEdit} className="table-icon-inline" />
            EDIT
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell: (row) => (
          <button
            id={row.id}
            className="btn btn-danger"
            onClick={() => this.deleteCommunication(row.id)}
          >
            {" "}
            <FontAwesomeIcon icon={faTrash} className="table-icon-inline" />
            DELETE
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell: (row) => (
          <button
            id={row.id}
            className="btn btn-warning"
            onClick={() => this.assignCommunicationOpen(row)}
            disabled={row.isAnnouncement ? true : false}
          >
            {" "}
            <FontAwesomeIcon icon={faUser} className="table-icon-inline" />
            ASSIGN
          </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,

      },
    ];
    this.state = {
      data: [],
      toggleForm: false,
      toggleAssign: false,
      deleteAlert: false,
      editForm: false,
      loader: false,
      assignAlert: false,
      unassignAlert: false,
      fullData: [],
    };
  }


  formatType = (type) => {
    if (type === true) return "ANNOUNCEMENT";
    return 'COMMUNICATION';
  }

  addCommunication = () => {
    this.setState({ toggleForm: true });
  };
  updateToggleFormVal = () => {
    this.setState({ toggleForm: false });
  };
  updateToggleAssign = () => {
    this.setState({ toggleAssign: false });
  };
  assignCommunicationOpen = (row) => {
    this.rowData = row;
    this.setState({ toggleAssign: true });
  };

  editCommunicationOpen = (row) => {
    this.rowData = row;
    this.setState({ editForm: true });
  };
  updateToggleEdit = () => {
    this.setState({ editForm: false });
  };
  componentDidMount() {
    //this.loadMasterData();
    this.listCommunication();
  }



  //Search fn
  filterData = (e) => {
    const key = e.target.value;
    let ar = [];
    this.state.fullData.forEach((element) => {
      if (element.name.toLowerCase().indexOf(key.toLowerCase()) > -1)
        ar.push(element);
    });
    this.setState({ data: ar });
  };
  //List communication
  listCommunication = () => {
    this.setState({ editForm: false });
    this.setState({ toggleForm: false });
    this.setState({ toggleAssign: false });
    this.setState({ loader: true });
    axios
      .get(API.listCommunication)
      .then((res) => {
        if (res && res.data && res.data.status === "S") {
          const data = res.data.communications;
          this.setState({ data });
          this.setState({ fullData: data });
        }
        this.setState({ loader: false });
      })
      .catch((er) => {
        this.setState({ loader: false });
      });
  };
  //Add new communication
  saveCommunication = (data) => {
    this.setState({ loader: true });
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("description", data.description);
    formData.append("mediaType", data.mediaType);
    formData.append("file", data.file);
    formData.append("validfrom", data.validfrom);
    formData.append("validto", data.validto);
    formData.append("isAnnouncement", data.isAnnouncement);
    axios
      .post(API.saveCommunication, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        if (resp && resp.data && resp.data.status === "S") {
          // this.setState({ toastToggle: true });
          toast.success('Communication added successfully.');
        } else {
          // this.setState({ errorToggle: true });
          toast.error('Failed to add communication.');
        }
      })
      .catch((ex) => {
        // this.setState({ errorToggle: true });
        toast.error('An error occurred while adding communication.');
      })
      .finally(() => {
        setTimeout(() => {
          this.setState({ loader: false });
          this.listCommunication();
        }, 1000);
      });
  };
  //Edit communication
  editCommunication = (data) => {
    this.setState({ loader: true });
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("name", data.name);
    formData.append("description", data.description);
    formData.append("mediaType", data.mediaType);
    if (data.file) {
      formData.append("file", data.file);
    }
    formData.append("validfrom", data.validfrom);
    formData.append("validto", data.validto);
    formData.append("isAnnouncement", data.isAnnouncement);

    axios
      .post(API.editCommunication, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        if (resp && resp.data && resp.data.status === "S") {
          // this.setState({ toastToggle: true });
          toast.success('Communication updated successfully.');
        } else {
          // this.setState({ errorToggle: true });
          toast.error('Failed to update communication.');
        }
      })
      .catch((ex) => {
        // this.setState({ errorToggle: true });
        toast.error('An error occurred while updating communication.');
      })
      .finally(() => {
        setTimeout(() => {
          this.setState({ loader: false });
          this.listCommunication();
        }, 1000);
      });
  };
  //Delete communication
  deleteCommunication = (id) => {
    // Show the confirmation dialog
    confirmAlert({
      message: 'Are you sure you want to delete?',
      buttons: [
        {
          label: 'YES',
          className: 'btn btn-success',
          onClick: () => {
            this.setState({ loader: true });
            axios
              .post(API.deleteCommunication, { id })
              .then((resp) => {
                if (resp && resp.data && resp.data.status === "S") {
                  // this.setState({ deleteAlert: true });
                  toast.success('Communication deleted successfully.');
                } else {
                  // this.setState({ errorToggle: true });
                  toast.error('Failed to delete communication.');
                }
              })
              .catch((ex) => {
                // this.setState({ errorToggle: true });
                toast.error('An error occurred while deleting communication.');
              })
              .finally(() => {
                setTimeout(() => {
                  this.setState({ loader: false });
                  this.listCommunication();
                }, 1000);
              });
          },
        },
        {
          label: 'CANCEL',
          className: 'btn btn-error',
          onClick: () => { },
        },
      ],
    });
  };

  //Assign communication
  assignCommunication = (data) => {
    this.setState({ loader: true });
    const req = {
      communicationId: this.rowData.id,
      dueDate: data.dueDate,
    };
    const typeMap = {
      D: 'groupId',
      P: 'project',
      L: 'level'
    }
    //attach project/level/groupId key
    req[typeMap[data.type]] = data.selected;

    axios
      .post(API.assignCommunication, req)
      .then((res) => {
        if (res && res.data && res.data.status === "S") {
          this.setState({ assignAlert: true });
        } else {
          this.setState({ errorToggle: true });
        }
      })
      .catch((er) => {
        this.setState({ errorToggle: true });
      })
      .finally(() => {
        setTimeout(() => {
          this.setState({ loader: false });
          this.listCommunication();
        }, 1000);
      });
  };

  //UnAssign communication
  unassignCommunication = (data) => {
    this.setState({ loader: true });
    const req = {
      communicationId: this.rowData.id,
      dueDate: data.dueDate,
    };
    const typeMap = {
      D: 'groupId',
      P: 'project',
      L: 'level'
    }
    req[typeMap[data.type]] = data.selected;
    axios.post(API.unassignCommunication, req)
      .then((res) => {
        if (res && res.data && res.data.status === "S") {
          this.setState({ unassignAlert: true });
        } else {
          this.setState({ errorToggle: true });
        }
      })
      .catch((er) => {
        this.setState({ errorToggle: true });
      })
      .finally(() => {
        setTimeout(() => {
          this.setState({ loader: false });
          this.listCommunication();
        }, 1000);
      });
  };

  render() {
    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        {this.state.assignAlert ? (
          <ToastComp
            case="assign-user"
            handler={() => {
              this.setState({ assignAlert: false });
            }}
          />
        ) : (
          ""
        )}
        {this.state.unassignAlert ? (
          <ToastComp
            case="unassign-user"
            handler={() => {
              this.setState({ unassignAlert: false });
            }}
          />
        ) : (
          ""
        )}
        {this.state.toastToggle ? (
          <ToastComp
            case="commu-add"
            handler={() => {
              this.setState({ toastToggle: false });
            }}
          />
        ) : (
          ""
        )}
        {this.state.errorToggle ? (
          <ToastComp
            case="error"
            handler={() => {
              this.setState({ errorToggle: false });
            }}
          />
        ) : (
          ""
        )}
        {this.state.editForm ? (
          <AddCommunication
            callback={(d) => this.editCommunication(d)}
            edit={true}
            data={this.rowData}
            handler={this.updateToggleEdit}
            flag={this.state.editForm ? true : false}
          />
        ) : (
          ""
        )}
        {this.state.deleteAlert ? (
          <ToastComp
            case="delete"
            handler={() => {
              this.setState({ deleteAlert: false });
            }}
          />
        ) : (
          ""
        )}
        {this.state.toggleForm ? (
          <AddCommunication
            callback={(d) => this.saveCommunication(d)}
            handler={this.updateToggleFormVal}
            flag={this.state.toggleForm ? true : false}
          />
        ) : (
          ""
        )}
        {this.state.toggleAssign ? (
          <AssignCommunication
            unassign={(data) => {
              this.unassignCommunication(data);
            }}
            assign={(data) => {
              this.assignCommunication(data);
            }}
            data={this.rowData}
            handler={this.updateToggleAssign}
            flag={this.state.toggleAssign ? true : false}
          />
        ) : (
          ""
        )}
        <div className="bread-crumb overflow-auto">
          <div>
            <span className="breadcrumb-title">
              <input
                type="button"
                className="btn"
                value="Home - Communication"
              ></input>
            </span>
            <span className="fr">
              <input
                type="button"
                className="btn btn-success"
                value="ADD COMMUNICATION"
                onClick={() => this.addCommunication()}
              ></input>
            </span>
          </div>
        </div>
        <div className="data-table-holder">
          <div className="table-search-box">
            {/* <FontAwesomeIcon icon={faSearch} className='table-icon-inline'/>  */}
            <input
              type="text"
              placeholder="Search Here.."
              className="form-control"
              onChange={(e) => this.filterData(e)}
            ></input>
          </div>
          <DataTable
            columns={this.columns}
            defaultSortFieldId="id"
            data={this.state.data}
            pagination
            striped
          />
        </div>
      </div>
    );
  }
}
